"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.styles = void 0;
var ui_common_1 = require("@codametrix/ui-common");
exports.styles = {
    button: __assign(__assign({ width: '100%', 'text-align': 'left', color: ui_common_1.theme.colors.text['highEmphasis'], 'font-family': 'Roboto' }, ui_common_1.theme.textStyles['Body 1']), { border: "1px solid ".concat(ui_common_1.theme.colors.stroke[200]), bgColor: ui_common_1.theme.colors.structural[0], px: ui_common_1.theme.space[8], borderRadius: ui_common_1.theme.radii[3], 'max-width': ui_common_1.theme.space[300], overflow: 'hidden', 'min-width': ui_common_1.theme.space[120] }),
    buttonSelected: __assign(__assign({ width: '100%', 'text-align': 'left', color: ui_common_1.theme.colors.text['highEmphasis'], 'font-family': 'Roboto' }, ui_common_1.theme.textStyles['Body 1']), { border: "".concat(ui_common_1.theme.borders['1px'], " ").concat(ui_common_1.theme.colors.stroke[200]), bgColor: ui_common_1.theme.colors.structural[0], paddingLeft: ui_common_1.theme.space[16], borderRadius: ui_common_1.theme.radii[3], 'max-width': ui_common_1.theme.space[300], overflow: 'hidden', 'min-width': ui_common_1.theme.space[120] }),
    list: {
        padding: '10px',
        'max-height': '40vh',
        'over-flow': 'auto'
    },
    item: {
        'margin-left': '0px',
        color: ui_common_1.theme.colors.text['mediumEmphasis']
    },
    itemSelected: {
        'margin-left': '0px',
        color: ui_common_1.theme.colors.accent[200],
        backgroundColor: ui_common_1.theme.colors.accent[50]
    },
    icon: {
        color: ui_common_1.theme.colors.foundation[300],
        'font-size': '2em'
    },
    formControl: {
        width: 'auto'
    },
    defaultFormControl: {
        width: '100%'
    }
};
//# sourceMappingURL=field-editorv2-styles.js.map